
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as LittlegroupIconComponent } from "./littlegroup-icon.svg";

export const LittlegroupIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <LittlegroupIconComponent {...props} />;
};
